import React from 'react';

export default function Cart({ cart, onRemove, onClear, onCheckout }) {
  const items = cart?.items || [];
  const total = items.reduce((s, l) => s + l.price * l.quantity, 0);

  return (
    <div className="cart">
      <div className="cart-head">
        <h2>🛒 Your Order</h2>
        {items.length > 0 && (
          <button className="link-btn" onClick={onClear}>Clear</button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="empty small">Cart is empty. Talk to Aina or tap + on any item.</div>
      ) : (
        <ul className="cart-lines">
          {items.map((l) => (
            <li key={l.menuItem} className="cart-line">
              <span className="cart-emoji">{l.emoji || '🍽️'}</span>
              <span className="cart-name">
                {l.name} <em>× {l.quantity}</em>
              </span>
              <span className="cart-price">RM {(l.price * l.quantity).toFixed(2)}</span>
              <button className="btn-remove" onClick={() => onRemove(l.menuItem)}>×</button>
            </li>
          ))}
        </ul>
      )}

      <div className="cart-total">
        <span>Total</span>
        <span>RM {total.toFixed(2)}</span>
      </div>

      <button className="btn-checkout" disabled={!items.length} onClick={onCheckout}>
        Place Order
      </button>
    </div>
  );
}
